
import {databaseInfo, setSession, getSession} from '../../tools/config'
let Database = {
  state: {
      database: {
          library_id: ''
    }
  },
  mutations: {
    setDatabase (state, database) {
      setSession(databaseInfo, database)
      state.database = database
    },
    resetDatabase (state) {
      setSession(databaseInfo, {})
      state.database = {}
    }
  },
  getters: {
    getDatabase (state) {
      if (!state.database.library_id) {
        state.database = getSession(databaseInfo)
      }
      return state.database
    }
  }
}

export default Database



// WEBPACK FOOTER //
// ./src/store/modules/database.js